import { Button, Form, Input, Modal, Popconfirm, Popover, Radio, Spin, notification, DatePicker, Tooltip } from 'antd';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { ReactSVG } from 'react-svg';
import { SPARQLE_DARK_BLUE } from '../../constants';
import { CodeTwoTone, RedoOutlined, TagTwoTone, TagsTwoTone } from '@ant-design/icons';

import { DAYTIME_FORMAT, DAY_FORMAT, ORDER_STATUSES, PAGE_SIZE, PAGE_SIZE_OPTIONS, ROLES } from '../../constants';

import { selectAllOrders } from '../../modules/orders/store/slice';
import {
  doDeleteOrder,
  doDeleteOrders,
  doGetOrders,
  doRetryOrder,
  doUpdateOrdersBatch,
} from '../../modules/orders/store/thunk';
import { doGetRiders } from '../../modules/riders/stores/thunk';
import OrdersFilter from '../Forms/Filters/OrdersFilter';
import OrdersTable from '../Tables/OrdersTable';
import ImportOrders from './Orders/ImportOrders';
import withPage from './withPage';
import { selectAllRoutePlans } from '../../modules/route-plans/stores/slice';
import { doAddOrdersToRoutePlan } from '../../modules/route-plans/stores/thunk';
import './Orders.scss';
import BulkAddToRoutePlanForm from './Orders/BulkAddToRoutePlan';
import BulkAddToRoutePlanError from './Orders/BulkAddToRoutePlanError';

import { BulkStatus } from './Orders/BulkStatus';

import dayjs from 'dayjs';
import { getLabels } from '../../modules/orders/api';
import { OrderAddressRetry } from './OrderRetry';
import { TraceLogs } from '../Modals/TraceLogs';
import usePageView from '../../hooks/usePageView';
// import { OrdersTable2 } from '../Tables/OrdersTable2';

const headersExport = [
  { label: 'ID', key: 'id' },
  { label: 'Order ID', key: 'orderId' },
  { label: 'Order Ref', key: 'orderRef' },
  { label: 'Delivery Date', key: 'deliveryDate' },
  { label: 'Company', key: 'company' },
  { label: 'Pickup Name', key: 'pickupName' },
  { label: 'Pickup Address', key: 'pickupAddress' },
  { label: 'Pickup Phone', key: 'pickupPhone' },
  { label: 'Delivery Name', key: 'deliveryName' },
  { label: 'Delivery Address', key: 'deliveryAddress' },
  { label: 'Delivery Phone', key: 'deliveryPhone' },
  { label: 'Delivery Time Window', key: 'deliveryTimeWindow' },
  { label: 'Load', key: 'load' },
  { label: 'Updated At', key: 'updatedAt' },
  { label: 'Status', key: 'status' },
  { label: 'barcodes', key: 'barcodes' },
  { label: 'tnt', key: 'tnt' },
  { label: 'Created at', key: 'createdAt' },
  { label: 'First scanned at', key: 'firstScannedAt' },
  { label: 'Completed at', key: 'completedAt' },
];

const typesModal = {
  upload: {
    key: 'upload',
    title: 'Upload Orders',
  },
  addRoute: {
    key: 'addRoute',
    title: 'Add to Existing Route Plan',
  },
  changeLocation: {
    key: 'changeLocation',
    title: 'Change the location for multiple orders',
  },
  addRouteError: {
    key: 'addRouteError',
    title: 'Failed to Add to Existing Route Plan',
    // eslint-disable-next-line max-len
    message:
      // eslint-disable-next-line max-len
      'You can only create a new route plan with orders on the same date, and only orders in draft status can be added to a route plan, whether new or existing. Please make sure your orders meet these criteria and try again.',
  },
};

const OrdersPage = ({ query, pushTo }) => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [formFilter] = Form.useForm();

  const csvLink = useRef();

  const isFetchingOrder = useSelector((state) => state.order.isFetching);
  const isFetchingRoute = useSelector((state) => state.routePlan.isFetching);
  const isFetchingRider = useSelector((state) => state.rider.isFetching);
  const userRole = useSelector((state) => state.auth.user.role);
  const isAdmin = useSelector((state) => state.auth.user.isAdmin);
  const action = useSelector((state) => state.order.action);
  const status = useSelector((state) => state.order.status);
  const metadata = useSelector((state) => state.order.metadata);
  const orders = useSelector((state) => selectAllOrders(state));
  const routePlans = useSelector((state) => selectAllRoutePlans(state));
  // const locations = useSelector((state) => selectAllLocations(state));
  // const companies = useSelector((state) => selectAllCompanies(state));

  // const riders = useSelector((state) => selectAllRiders(state));
  const [searchValue, setSearchValue] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [visibleImportModal, setVisibleImportModal] = useState(false);
  const [typeModal, setTypeModal] = useState();

  const isFetching = isFetchingRoute || isFetchingOrder || isFetchingRider;
  // const [companySelectId, setCompanySelectId] = useState('');
  // const [optionsLocation, setOptionsLocation] = useState([]);
  const [optionsCarrier, setOptionsCarrier] = useState('all');
  const [failedBatch, setFailedBatch] = useState([]);
  const [retryOrderAddress, setRetryOrderAddress] = useState(null);
  const [isPrintingLabels, setIsPrintingLabels] = useState(false);

  const roleOptions = [
    { label: 'Carrier', value: 'carrier' },
    { label: 'Provider', value: 'provider' },
    { label: 'All', value: 'all' },
  ];

  // Emit page view event
  usePageView(window.location.href);

  const onSelectChange = (newSelectedRowKeys) => {
    if (newSelectedRowKeys.length === 0 && isActionOpen) setIsActionOpen(false);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const clickUploadOrders = () => {
    setTypeModal(typesModal.upload.key);
    setVisibleImportModal(true);
  };

  // const clickAddRouteToOrders = () => {
  //   setTypeModal(typesModal.addRoute.key);
  //   setIsActionOpen(false);
  //   setVisibleImportModal(true);
  // };

  const onClickAction = () => {
    selectedRowKeys.length > 0 && setIsActionOpen(!isActionOpen);
  };

  useEffect(() => {
    if (transactionData.length > 0) {
      csvLink.current.link.click();
      setTransactionData([]);
    }
  }, [transactionData]);

  const showPrintLabels = useMemo(
    () =>
      orders
        .filter((o) => selectedRowKeys.includes(o.id))
        .every((o) => ['DRAFT', 'READY_TO_LABEL'].some((s) => o.status === s)),
    [orders, selectedRowKeys],
  );

  const handleExportCSV = () => {
    const ordersFilter = orders.filter((order) => selectedRowKeys.includes(order.id));
    const rs = ordersFilter.map((row) => {
      return {
        ...row,
        deliveryTimeWindow: (row.deliveryTimeStart || '') + ' - ' + (row.deliveryTimeEnd || ''),
        updatedAt: row.updatedAt ? moment(row.updatedAt).format(DAYTIME_FORMAT) : '',
        status: row.status?.split('_').join(' '),
        deliveryDate: row.deliveryDate ? moment(row.deliveryDate).format(DAY_FORMAT) : '',
        company: row.location?.company?.name || '',
        barcodes: row.colli.map((c) => c.barcode).join(','),
        tnt:
          row.createdBy === 'Ricoh'
            ? `${process.env.REACT_APP_TRACKING_URL}barcode/${row.colli[0].barcode}`
            : `${process.env.REACT_APP_TRACKING_URL}${row.orderId}`,
      };
    });
    setTransactionData(rs);
  };

  const handleClickDeleteOrders = () => {
    if (isActionOpen) setIsActionOpen(false);
    const orderIdsRemove = orders
      .filter((o) => selectedRowKeys.includes(o.id) && ['DRAFT'].includes(o.status))
      ?.map((o) => o.id);
    if (orderIdsRemove.length !== selectedRowKeys.length) {
      const errorIds = [];
      selectedRowKeys.forEach((id) => {
        if (!orderIdsRemove.includes(id)) errorIds.push(id);
      });
      const orderCodesError = orders.filter((o) => errorIds.includes(o.id))?.map((o) => o.orderId);
      api.error({
        message: `We're sorry, but we can't delete these orders: ${orderCodesError.join(
          ', ',
        )} at the moment. Orders can only be deleted when they are not confirmed yet.`,
        style: { top: '52px' },
      });
    } else {
      const orderIds = orders.filter((o) => selectedRowKeys.includes(o.id)).map((o) => o.orderId);
      dispatch(doDeleteOrders({ orderIds }));
    }
  };
  // for now inline, could be moved to model later on
  const canBeRemoved = (order) => {
    if (order.orderId === 'BM8NY16ARK') {
      console.log(order);
    }
    return (
      (!order.externalIds || order.externalIds.length === 0) &&
      [ORDER_STATUSES.DRAFT, ORDER_STATUSES.ERROR, ORDER_STATUSES.ADDRESS_NOT_FOUND].includes(order.status)
    );
  };

  const contentPopoverAction = () => {
    const showDelete = orders.filter((o) => selectedRowKeys.includes(o.id)).every(canBeRemoved); // This disables removing multiple orders at the same time

    const showBulkStatus = useMemo(
      () =>
        (userRole === ROLES.ADMIN &&
          orders.filter((o) => selectedRowKeys.includes(o.id)).every((o) => o.status !== ORDER_STATUSES.COMPLETED)) ||
        ([ROLES.COMPANY_OWNER, ROLES.LOCATION_MANAGER].includes(userRole) &&
          orders.filter((o) => selectedRowKeys.includes(o.id)).every((o) => o.status === ORDER_STATUSES.DRAFT)),
      [selectedRowKeys, userRole, orders],
    );

    const [confirmLabels, setConfirmLabels] = useState(false);
    const [labelResponse, setLabelResponse] = useState(null);

    const fetchLabels = async () => {
      setIsPrintingLabels(true);
      const orderIds = orders.filter((o) => selectedRowKeys.includes(o.id)).map((o) => o.orderId);
      try {
        const { response } = await getLabels({ orderIds });

        setLabelResponse(response);
        if (response.failed?.length === 0) {
          printLabels(response);
        }
      } catch (e) {
        setLabelResponse({ error: e.message });
        setIsPrintingLabels(false);
      }
      dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, roleType: optionsCarrier, ...query }));
      setIsPrintingLabels(false);
    };

    const printLabels = async (response) => {
      try {
        const pdfData = response.labels;
        const pdfBlob = await (await fetch(`data:application/pdf;base64,${pdfData}`)).blob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
        setLabelResponse(null);
      } catch (error) {
        console.error('Error while opening label PDF:', error.message);
        alert('An error occurred while trying to open the label PDF. Please try again later or contact support.');
      }
    };

    const conditionalConfirm = (newOpen) => {
      if (!newOpen) {
        setConfirmLabels(newOpen);
        return;
      }

      if (orders.filter((o) => selectedRowKeys.includes(o.id)).some((o) => o.status === ORDER_STATUSES.COMPLETED)) {
        setConfirmLabels(newOpen);
      } else {
        fetchLabels(); // skip popconfirm
      }
    };

    return (
      <div className="buttons">
        <Button type="link" onClick={handleExportCSV}>
          <ReactSVG className="icon" src="/icons/export.svg" />
          Export to CSV
        </Button>

        {userRole === ROLES.ADMIN && (
          <Popover
            content={<BulkStatus onSelect={submitBulkOrderUpdate} />}
            overlayClassName="OrdersPagePopoverAction"
            zIndex={10000}
            placement="right"
          >
            <Button type="link">
              <TagTwoTone twoToneColor={`#${SPARQLE_DARK_BLUE}`} />
              Status
            </Button>
          </Popover>
        )}
        {userRole !== ROLES.CARRIER_USER && (
          <>
            <Button type="link">
              <ReactSVG className="icon" src="/icons/force.svg" />
              Date
              <Tooltip
                placement="right"
                title={
                  showBulkStatus
                    ? ''
                    : userRole === ROLES.ADMIN
                      ? 'You cannot change dates for orders that are completed'
                      : 'You can only change dates for draft orders'
                }
              >
                <DatePicker
                  style={{ marginLeft: '10px' }}
                  format={DAY_FORMAT}
                  minDate={dayjs()}
                  disabled={!showBulkStatus}
                  onChange={(v) => v && submitBulkOrderUpdate({ deliveryDate: v.format('YYYY-MM-DD') })}
                />
              </Tooltip>
            </Button>
            <Popconfirm
              title="Completed orders selected"
              description="Are you sure you want to print all labels?"
              placement="right"
              open={confirmLabels}
              onOpenChange={conditionalConfirm}
              onConfirm={fetchLabels}
            >
              <Tooltip title={showPrintLabels ? '' : 'Only DRAFT and READY TO LABEL can be printed'}>
                <Button type="link" disabled={!showPrintLabels || isPrintingLabels}>
                  <TagsTwoTone twoToneColor={`#${SPARQLE_DARK_BLUE}`} />
                  Print labels
                </Button>
              </Tooltip>
            </Popconfirm>

            {showDelete && (
              <Popconfirm
                title="Are you sure to delete?"
                onConfirm={() => handleClickDeleteOrders()}
                okText="Yes"
                cancelText="No"
              >
                <Button type="link">
                  <ReactSVG className="icon" src="/icons/delete.svg" />
                  Delete
                </Button>
              </Popconfirm>
            )}
          </>
        )}
        {/* <Button type="link" onClick={clickAddRouteToOrders}>
          <ReactSVG className="icon" src="/icons/plus.svg" />
          Add to Existing Route Plan
        </Button> */}
        <Modal
          width="500px"
          closeIcon={false}
          open={!!labelResponse?.failed?.length}
          forceRender
          title="Some labels could not be fetched"
        >
          <div>
            Failed to fetch labels for orders:
            <ul>
              {labelResponse?.failed.map((e) => (
                <li key={e.orderId} style={{ color: 'red' }}>
                  <div>
                    <span>{e.orderId}:</span>
                    <span style={{ marginLeft: 8 }}>{e.reason}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Button type="primary" onClick={() => printLabels(labelResponse)}>
              Show successful labels
            </Button>
          </div>
        </Modal>
      </div>
    );
  };

  const currentPage = Number(query.current) || 1;
  const itemsPerPage = Number(query.pageSize) || PAGE_SIZE;

  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    locale: { items_per_page: 'Orders/Page' },
    total: metadata?.totalItems || 0,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showSizeChanger: true,
    showTotal: (total) => `${total} Orders`,
  };

  useEffect(() => {
    setSearchValue(query.q || '');
  }, []);

  useEffect(() => {
    if (!visibleImportModal) setTypeModal(undefined);
  }, [visibleImportModal]);

  useEffect(() => {
    // dispatch(doGetLocations());
    // dispatch(doGetCompanies());
    if (userRole == ROLES.ADMIN) {
      dispatch(doGetRiders());
    }
    dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, roleType: optionsCarrier, ...query }));
  }, []);

  useEffect(() => {
    dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, roleType: optionsCarrier, ...query }));
  }, [optionsCarrier]);

  useEffect(() => {
    if (retryOrderAddress === null) {
      dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, roleType: optionsCarrier, ...query }));
    }
  }, [retryOrderAddress]);

  useEffect(() => {
    if (['create', 'update', 'import', 'delete', 'delete-multi'].includes(action) && status === 'succeeded') {
      dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, ...query }));
      if (selectedRowKeys.length) setSelectedRowKeys([]);
    }
  }, [isFetching]);

  const handleFilter = (params, updatePath) => {
    delete params.pageSizeOptions;
    delete params.showSizeChanger;
    delete params.total;
    delete params.locale;
    delete params.page;
    if (updatePath) {
      pushTo({ query: params });
    }
    const newCurrentPage = Number(params?.current || 1);
    const newItemsPerPage = Number(params?.pageSize) || PAGE_SIZE;
    dispatch(
      doGetOrders({
        page: newCurrentPage,
        take: newItemsPerPage,
        roleType: optionsCarrier,
        ...params,
      }),
    );
  };

  const filteredOrders = useMemo(() => {
    // If the status is specifically set to REJECTED, filter to only include those orders.
    if (query.statuses === ORDER_STATUSES.REJECTED) {
      return orders.filter((order) => order.status === ORDER_STATUSES.REJECTED);
    }
    // Otherwise, exclude REJECTED orders from the list.
    return orders.filter((order) => order.status !== ORDER_STATUSES.REJECTED);
  }, [orders, query.status]);

  const handleTableChange = (params) => {
    const newParams = { ...query, ...params };
    handleFilter(newParams, true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch && handleSearch();
    }
  };

  const handleChangeSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearch = () => {
    handleFilter({ q: searchValue || '' }, true);
  };

  const onClickRetry = async (record) => {
    if (record.status === 'ADDRESS_NOT_FOUND') {
      // handle address retry
      setRetryOrderAddress(record);
    } else if (record.status === 'ERROR') {
      // handle error retry
      await dispatch(doRetryOrder({ orderId: record.orderId }));
    }
    await dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, ...query }));
  };

  const handleClickDelete = (id) => {
    dispatch(doDeleteOrder({ id }));
  };
  const [showLogsForOrder, setShowLogsForOrder] = useState(null);

  const withAction = (record) => {
    return (
      <div className="actions">
        {record.status === 'ADDRESS_NOT_FOUND' && (userRole === ROLES.ADMIN || userRole === ROLES.COMPANY_OWNER) && (
          <Button type="link" className="edit" onClick={() => onClickRetry(record)}>
            <RedoOutlined />
          </Button>
        )}
        {record.status === 'ERROR' &&
          record.externalIds.length === 0 &&
          (userRole === ROLES.ADMIN || userRole === ROLES.COMPANY_OWNER) && (
            <Popconfirm
              title="Retry to register this order with carrier"
              icon={<RedoOutlined />}
              description="Are you sure to retry this order?"
              onConfirm={() => onClickRetry(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="link" className="edit">
                <RedoOutlined />
              </Button>
            </Popconfirm>
          )}
        <div className="line"></div>

        {canBeRemoved(record) && (
          <Popconfirm
            title="Are you sure you want to delete this order?"
            onConfirm={() => handleClickDelete(record.orderId)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" className="more">
              <ReactSVG className="icon" src="/icons/delete.svg" />
            </Button>
          </Popconfirm>
        )}
        {isAdmin && (
          <Button type="link" className="more" onClick={() => setShowLogsForOrder(record.id)}>
            <CodeTwoTone />
          </Button>
        )}
      </div>
    );
  };

  const handleCancelModal = () => {
    setVisibleImportModal(false);
  };

  const submitBulkOrderUpdate = async (value) => {
    const update = {
      update: {
        items: orders
          .filter((o) => selectedRowKeys.includes(o.id))
          .map((o) => ({
            id: o.id,
            orderId: o.orderId,
            ...value,
          })),
      },
    };
    const res = await dispatch(doUpdateOrdersBatch(update));

    if (res.payload?.failedOrders) {
      setFailedBatch(res.payload.failedOrders);
    }
    setIsActionOpen(false);
  };

  const submitAddOrderToRoute = async (values) => {
    const routePlan = routePlans.find((r) => r.id === values.routePlanId);
    const deliveryDate = moment(routePlan.deliveryDate).utc().format(DAY_FORMAT);
    const ordersFilter = orders.filter((order) => selectedRowKeys.includes(order.id));
    const matchedOrders = ordersFilter.filter(
      (o) => moment(o.deliveryDate).utc().format(DAY_FORMAT) === deliveryDate && o.status === ORDER_STATUSES.DRAFT,
    );
    if (matchedOrders.length !== ordersFilter.length) {
      setTypeModal(typesModal.addRouteError.key);
    } else {
      await dispatch(doAddOrdersToRoutePlan({ id: routePlan.slug, orders: matchedOrders.map((mo) => mo.id) }));
      dispatch(doGetOrders({ page: currentPage, take: itemsPerPage, ...query }));
      handleCancelModal();
    }
  };

  return (
    <Spin spinning={isFetching || isPrintingLabels}>
      <CSVLink
        headers={headersExport}
        data={transactionData}
        filename="orders.csv"
        className="hidden"
        ref={csvLink}
        target="_blank"
      />
      {contextHolder}
      <div className="Content OrdersPage">
        <div className="ContentHeader">
          <div className="HeaderTitle">Orders</div>
          <div className="HeaderToolBar">
            {userRole !== ROLES.CARRIER_USER && (
              <div className="ToolBarButtons">
                <Link to={`/orders/new`} className="new_order">
                  <Button className="CreateButton ButtonPrimary" type="primary" size="small">
                    Create New Order
                    <ReactSVG className="icon" src="/icons/plus.svg" />
                  </Button>
                </Link>
                <Button className="CreateButton ButtonWhite" size="small" onClick={clickUploadOrders}>
                  Upload Order
                  <ReactSVG className="icon" src="/icons/upload.svg" />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="orders-header-table page-header-table">
          <div className="search">
            <Input
              onChange={handleChangeSearch}
              onBlur={handleSearch}
              placeholder="Search"
              onKeyDown={handleKeyDown}
              suffix={<img src="/icons/search.svg" />}
              disabled={isFetching}
              value={searchValue}
            />
          </div>
          <div className="buttons">
            {selectedRowKeys.length > 0 && (
              <Popover
                open={selectedRowKeys?.length > 0 && isActionOpen}
                content={contentPopoverAction}
                overlayClassName="OrdersPagePopoverAction"
                placement="bottom"
              >
                <Button className="FilterButton ButtonFilter" onClick={onClickAction}>
                  {selectedRowKeys?.length > 0 && <div className="count">{selectedRowKeys.length}</div>}
                  Action <ReactSVG className="icon" src="/icons/arrow_drop_down.svg" />
                </Button>
              </Popover>
            )}

            {userRole === ROLES.ADMIN && (
              <>
                <Radio.Group
                  options={roleOptions}
                  onChange={(e) => setOptionsCarrier(e.target.value)}
                  value={optionsCarrier}
                />
              </>
            )}

            {userRole !== ROLES.CARRIER_USER && (
              <Button className="FilterButton ButtonFilter" onClick={() => setIsFilterOpen(!isFilterOpen)}>
                Filter
                <ReactSVG className="icon" src="/icons/filter_list.svg" />
              </Button>
            )}
          </div>
        </div>
        {isFilterOpen && (
          <OrdersFilter
            isFetching={isFetching}
            query={query}
            form={formFilter}
            onSubmit={handleFilter}
            //tags={tags}
            //riders={riders}
            //companies={companies}
            //companySelectId={companySelectId}
            //changeSelectCompanyId={changeSelectCompanyId}
            //optionsLocation={optionsLocation}
            setTransactionData={setTransactionData}
          />
        )}
        <div className="ContentMain">
          <OrdersTable
            onChange={handleTableChange}
            dataSource={filteredOrders}
            pagination={pagination}
            withAction={withAction}
            rowKey="id"
            isFetching={isFetching}
            selectedRowKeys={selectedRowKeys}
            onSelectChange={onSelectChange}
          />
        </div>
      </div>
      <Modal
        width="700px"
        closeIcon={false}
        open={visibleImportModal}
        forceRender
        title={typesModal[typeModal]?.title || ''}
      >
        {typeModal === typesModal.upload.key && <ImportOrders onCancel={() => setVisibleImportModal(false)} />}
        {typeModal === typesModal.addRoute.key && (
          <BulkAddToRoutePlanForm
            form={form}
            isFetching={isFetching}
            handleCancel={handleCancelModal}
            handleSubmit={submitAddOrderToRoute}
          />
        )}

        {typeModal === typesModal.addRouteError.key && (
          <BulkAddToRoutePlanError
            message={typesModal.addRouteError.message}
            isFetching={isFetching}
            handleCancel={handleCancelModal}
          />
        )}
      </Modal>
      <Modal width="80%" closeIcon={false} open={failedBatch?.length > 0} forceRender title="Some order updates failed">
        {failedBatch?.map((o) => {
          return (
            <div key={o.order.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>{o.order.orderId}</div>
              <div>{o.error}</div>
            </div>
          );
        })}
        <Button onClick={() => setFailedBatch(null)}>Close</Button>
      </Modal>
      <TraceLogs
        close={() => setShowLogsForOrder(null)}
        show={!!showLogsForOrder}
        preset={{ subject: 'ORDER', subjectId: showLogsForOrder }}
      />
      <OrderAddressRetry order={retryOrderAddress} close={() => setRetryOrderAddress(null)} />
    </Spin>
  );
};
export default withPage(OrdersPage);
